"use client"

import Link from "next/link"
import { Button } from "../ui/button"
import { Separator } from "../ui/separator"
import { Facebook, Instagram, Mail, MapPin } from "lucide-react"

const navigation = {
  main: [
    { name: "Accueil", href: "/" },
    { name: "À propos", href: "/a-propos" },
    { name: "Services", href: "/services" },
    { name: "Blog", href: "/blog" },
    { name: "Contact", href: "/contact" },
  ],
  services: [
    { name: "Gestion du stress", href: "/services#stress" },
    { name: "Troubles du sommeil", href: "/services#sommeil" },
    { name: "Confiance en soi", href: "/services#confiance" },
    { name: "Préparation mentale", href: "/services#preparation" },
  ],
  legal: [
    { name: "Mentions légales", href: "/mentions-legales" },
    { name: "Politique de confidentialité", href: "/politique-confidentialite" },
    { name: "CGV", href: "/cgv" },
  ],
}

const currentYear = new Date().getFullYear()

export default function Footer() {
  return (
    <footer className="border-t border-primary-100 bg-cream">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="font-serif text-xl">Marjory Sophrologie</h3>
            <div className="space-y-2 text-muted-foreground text-sm">
              <p className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                91 - Essonne
              </p>
              <p className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                <a 
                  href="mailto:contact@marjorysophrologie.fr" 
                  className="hover:text-primary transition-colors"
                >
                  contact@marjorysophrologie.fr
                </a>
              </p>
            </div>
            <div className="flex gap-4">
              <Button variant="ghost" size="icon" asChild>
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  <Facebook className="h-4 w-4" />
                  <span className="sr-only">Facebook</span>
                </a>
              </Button>
              <Button variant="ghost" size="icon" asChild>
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors"
                >
                  <Instagram className="h-4 w-4" />
                  <span className="sr-only">Instagram</span>
                </a>
              </Button>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {navigation.main.map((item) => (
                <li key={item.href}>
                  <Link 
                    href={item.href} 
                    className="hover:text-primary transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {navigation.services.map((item) => (
                <li key={item.href}>
                  <Link 
                    href={item.href} 
                    className="hover:text-primary transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Informations légales</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              {navigation.legal.map((item) => (
                <li key={item.href}>
                  <Link 
                    href={item.href} 
                    className="hover:text-primary transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {currentYear} Marjory Sophrologie. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  )
}